import { render, staticRenderFns } from "./SageMethodComponent.vue?vue&type=template&id=8ef34fae"
import script from "./SageMethodComponent.vue?vue&type=script&lang=js"
export * from "./SageMethodComponent.vue?vue&type=script&lang=js"
import style0 from "./SageMethodComponent.vue?vue&type=style&index=0&id=8ef34fae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports